module.exports = __webpack_public_path__ + "img/华侨报刊大系封面.8723747c.jpg";